<template>
  <v-dialog
    :value="value"
    max-width="600px"
    @input="$emit('input', $event)"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <p v-if="selectedPages.length === 0" class="caption mb-2">
          No pages selected: this role has no restrictions.
        </p>
        <div v-else class="mb-4">
          <v-chip
            v-for="page in selectedPages"
            :key="page.name"
            class="ma-1"
            close
            @click:close="removePage(page.name)"
          >
            {{ page.path }}
          </v-chip>
        </div>
        <v-autocomplete
          v-model="pageToAdd"
          :items="availableRoutes"
          item-text="path"
          item-value="name"
          label="add page"
          placeholder="type to search pages"
          clearable
          @change="addPage"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RolePagesDialog',
  props: {
    value: {type: Boolean, required: true},
    title: {type: String, default: 'Pages'},
    // route names currently assigned to the role
    pages: {type: Array, default: () => []},
    // all routes that can be assigned: [{name, path}]
    routes: {type: Array, default: () => []}
  },
  data() {
    return {
      editPages: [...this.pages],
      pageToAdd: null
    }
  },
  watch: {
    value(showing) {
      if (showing) {
        this.editPages = [...this.pages];
        this.pageToAdd = null;
      }
    }
  },
  computed: {
    selectedPages() {
      return this.editPages.map(name => {
        const route = this.routes.find(r => r.name === name);
        return route || {name, path: name};
      });
    },
    availableRoutes() {
      return this.routes.filter(r => !this.editPages.includes(r.name));
    }
  },
  methods: {
    addPage(name) {
      if (name && !this.editPages.includes(name)) {
        this.editPages.push(name);
      }
      this.$nextTick(() => {
        this.pageToAdd = null;
      });
    },
    removePage(name) {
      this.editPages = this.editPages.filter(p => p !== name);
    },
    save() {
      this.$emit('save', [...this.editPages]);
      this.$emit('input', false);
    },
    cancel() {
      this.$emit('input', false);
    }
  }
}
</script>
